import { NewsList } from "@/components/News/NewsList";
import { News } from "@/models/types";
import { PostOrPage } from "@tryghost/content-api";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Head from "next/head";
import { Footer } from "../../../components/Footer";
import { StaticGhostPage } from "../../../components/StaticGhostPage";
import { Nav } from "../../../components/common/FrontendNav";
import getPage from "../../../news/getPage";
import { getPokalNews, getSidebar } from "@/data/news";
import { setGhostCacheHeader } from "@/helper/cacheHeaders";

export async function getServerSideProps(context: any) {
  const { res } = context;
  setGhostCacheHeader(res);
  const page = await getPage(
    context.locale === "de"
      ? "6495554b0f1ea200015acdbb"
      : "64cb61da193d060001d02e39",
  );
  const { news } = await getPokalNews({
    locale: context.locale,
  });
  const sidebar = await getSidebar(context.locale);

  return {
    props: {
      page,
      sidebar,
      news,
      ...(await serverSideTranslations(context.locale)),
    },
  };
}

interface NewsPageProps {
  page: PostOrPage;
  sidebar: PostOrPage;
  news: News[];
}
export default function NewsPage({ page, news, sidebar }: NewsPageProps) {
  const { t } = useTranslation();
  return (
    <>
      <Head>
        <title>{`${t("Table_Tennis")} Bundesliga - TTBL - ${t(
          "Title_Pokal_Finals",
        )}`}</title>
      </Head>
      <div>
        <Nav />
        <StaticGhostPage page={page} sidebar={sidebar} />
        {news.length > 0 && (
          <div className="container container_py">
            <NewsList news={news} title="Pokal News" type="pokal" />
          </div>
        )}
        <Footer />
      </div>
    </>
  );
}
